// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--FwLYk","text1":"text1--2yxp8","text2":"text2--3sAzM"};